type Variant = "contained" | "outlined" | "text";
type Color = "primary" | "secondary" | "destructive";

interface GetColorOnConditionParams {
	iconColor?: string;
	variant: Variant;
	color: Color;
	disabled: boolean;
}

const getColorContainer = (color: Color, disabled: boolean): string => {
	if (disabled) {
		return "var(--icon-disabled)";
	}
	if (color === "primary" || color === "destructive") {
		return "var(--background-primary)";
	}
	return "var(--icon-primary)";
};
const getColorOther = (color: Color, disabled: boolean): string => {
	if (disabled) {
		return "var(--icon-disabled)";
	}
	if (color === "primary") {
		return "var(--interactive-text-primary)";
	}
	if (color === "destructive") {
		return "var(--red-500)";
	}
	return "var(--text-primary)";
};
export function getColorOnCondition({ iconColor, variant, color, disabled }: GetColorOnConditionParams): string {
	if (!iconColor) {
		if (variant === "contained") {
			return getColorContainer(color, disabled);
		}
		return getColorOther(color, disabled);
	}
	return disabled ? "var(--icon-disabled)" : iconColor;
}
